import ZPusher from 'zpusher-client';
import config from './config';

const ZPusherClient = new ZPusher({
    endpoint: ((config && config.zpusher && config.zpusher.endpoint) ? config.zpusher.endpoint : null),
    token:    ((config && config.zpusher && config.zpusher.key)      ? config.zpusher.key      : null),
    autoconnect: false
});

export default ZPusherClient;


// WEBPACK FOOTER //
// ./src/zpusher.js